import React from 'react';
import PageHeader from './page/PageHeader';

/**
 * Company logo + name header shared by the in-app dashboard and the public shared page
 * (Commandment VIII). `branding` is the output of utils/dashboardBranding.js. The logo URL is rendered
 * exactly as supplied (a server-minted SAS URL) - this component never derives or re-signs one.
 * Delegates to the shared PageHeader so the heading looks the same as every other page.
 */
const DashboardBrandHeader = ({ branding, title, subtitle, actions }) => (
  <PageHeader branding={branding} title={title} subtitle={subtitle} actions={actions} />
);

export default DashboardBrandHeader;
